import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { HttpClient, HttpBackend } from '@angular/common/http';
import swal from 'sweetalert2';
import { apiURL, secretKey } from '../data/urls';
import { NgbModal, ModalDismissReasons, NgbTypeahead } from '@ng-bootstrap/ng-bootstrap';
import { encryptValue, decryptValue } from '../data/encryption';
import { jwtDecode } from "jwt-decode";

@Injectable()
export class AuthService {
  token: string;
  decodedToken: any;

  constructor(private http: HttpClient,
    private router: Router,
    private modalService: NgbModal,
    private httpBackend: HttpBackend
  ) {
    this.http = new HttpClient(httpBackend)
  }

  loginUser(uname: string, uPassword: string) {

    localStorage.setItem('BaseURL', encryptValue(apiURL.URL));
    return new Promise(resolve => {
      const reqBody = { username: uname, password: uPassword };
      const decryptedValueForBaseURL = decryptValue(localStorage.getItem('BaseURL'));

      this.http.post<any>(decryptedValueForBaseURL + '/authenticate_service/authenticate', reqBody)
        .subscribe((PostData) => {
          // console.log("Token",PostData.token)
          this.decodedToken = jwtDecode(PostData.token);
          // console.log("this.decodedToken", this.decodedToken)
          //   this.GetUserRoles(this.decodedToken.user_Id)
          // .then(() => {

          localStorage.setItem('uname', encryptValue(uname));
          // localStorage.setItem('uPassword', CryptoJS.AES.encrypt(uPassword).toString());
          localStorage.setItem('UserName', encryptValue(this.decodedToken.user_Name));
          localStorage.setItem('UserId', encryptValue(JSON.stringify(this.decodedToken.user_Id)));
          if (this.decodedToken.AUTH_TYPE == "TFA") {
            if (this.decodedToken.TFA_TOKEN != null && this.decodedToken.TFA_TOKEN != "" && this.decodedToken.TFA_INITIAL_VERIFICATION == "Y") {
              swal.fire({
                title: 'Enter Authenticator Code',
                input: 'text',
                inputPlaceholder: '6-digit code',
                // inputClass: 'col-md-4',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Submit'
              }).then((result) => {
                if (result.value) {
                  let reqBody = {
                    UserToken: result.value.trim(),
                    UserId: decryptValue(localStorage.getItem('UserId'))
                  }
                  this.http.post<any>(decryptedValueForBaseURL + '/tfa_service/tfa/verify', reqBody)
                    .subscribe((response) => {
                       console.log("PostData", PostData);
                      if (response["status"] == 200) {
                        localStorage.setItem('UserEmail', encryptValue(this.decodedToken.EMAIL));
                        localStorage.setItem('UserToken', encryptValue(PostData.token));
                        localStorage.setItem('IsAuthSuccessful', encryptValue('true'));
                        localStorage.setItem('SessionTimer', encryptValue(JSON.stringify(this.decodedToken.sessionTimer)));
                        localStorage.setItem('RoleAliasName', encryptValue(JSON.stringify(this.decodedToken.userRoleNames)));
                        localStorage.setItem('Roles', encryptValue(JSON.stringify(this.decodedToken.userRoleAliasNames)));
                        localStorage.setItem('IsCustomer', encryptValue(this.decodedToken.isCustomer));
                        localStorage.setItem('IsCustomerAdmin',encryptValue(this.decodedToken.isCustomerAdmin) )
                        if (this.decodedToken.operator) {
                          localStorage.setItem('operator', encryptValue(this.decodedToken.operator.join(',')));
                        }
                        let isAdmin = this.isAdmin() ? "true" : "false";
                        localStorage.setItem('isAdmin', encryptValue(isAdmin));
                        // const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

                        if (localStorage.getItem('isMobile') && decryptValue(localStorage.getItem('isMobile')) == "true") {
                          this.getLatestSampleDetails(decryptValue(localStorage.getItem('QRSerialId')))
                          .then(() => {
                            this.router.navigate(['/sample/add']);
                          })
                          .catch(() => {
                            this.router.navigate(['/sample/add']);
                          });
                        }
                        else if (localStorage.getItem('boxDataQR') && decryptValue(localStorage.getItem('boxDataQR')) == "true") {
                          this.router.navigate(['/sample/addboxData']);
                        }
                         else {
                          this.router.navigate(['/sample/listing']);
                        }
                       // this.router.navigate(['/sample/listing']);
                      }
                      else {
                        swal.fire({
                          title: 'Invalid OTP',
                          text: "Invalid OTP, please try again..!",
                          icon: 'error'
                        });
                        let resObj = {
                          "RedirectUrl": "/pages/login",
                          "Error": "Invalid OTP"
                        }
                        // resolve(resObj);
                      }
                    });
                }
              });
            }
            else {

              //Generate new TOTP token.
              let reqBody = {
                UserId: this.decodedToken.user_Id
              }
              this.http.post<any>(decryptedValueForBaseURL + '/tfa_service/tfa/setup', reqBody)
                .subscribe((tfaSetupRes) => {
                  if (tfaSetupRes['status'] === 200) {
                    let tfa = tfaSetupRes;
                    let resObj = {
                      "RedirectUrl": "/tfa/setup",
                      "Error": "TFA set-up initiated",
                      "tfaDetails": tfa
                    }
                    resolve(resObj);
                  }
                });
            }
          }

          else if (this.decodedToken.MFA == "Y") {
            this.http.put<any>(decryptValue(localStorage.getItem('BaseURL')) + '/user_details_service/user_details_MFA/Id/' + this.decodedToken.user_Id, [])
              .subscribe((PostDataUserAccounts) => {
                swal.fire({
                  title: 'Enter Verification Code',
                  input: 'text',
                  inputPlaceholder: '6-digit code',
                  // inputClass: 'col-md-4',
                  showCancelButton: true,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#d33',
                  confirmButtonText: 'Submit'
                }).then((result) => {
                  if (result.value) {
                    this.http.get<any>(decryptValue(localStorage.getItem('BaseURL')) + '/user_details_service/user_details_MFA/validate/' + this.decodedToken.user_Id + '/MFA/' + result.value.trim())
                      .subscribe((response) => {
                        if (response.message) {
                          localStorage.setItem('UserEmail', encryptValue(this.decodedToken.email));
                          localStorage.setItem('UserToken', encryptValue(PostData.token));
                          localStorage.setItem('IsAuthSuccessful', encryptValue('true'));
                          localStorage.setItem('SessionTimer', encryptValue(JSON.stringify(this.decodedToken.sessionTimer)));
                          localStorage.setItem('RoleAliasName', encryptValue(JSON.stringify(this.decodedToken.userRoleNames)));
                          localStorage.setItem('Roles', encryptValue(JSON.stringify(this.decodedToken.userRoleAliasNames)));
                          localStorage.setItem('IsCustomer', encryptValue(this.decodedToken.isCustomer));
                          localStorage.setItem('IsCustomerAdmin',encryptValue(this.decodedToken.isCustomerAdmin));
                          if (this.decodedToken.operator) {
                            localStorage.setItem('operator', encryptValue(this.decodedToken.operator.join(',')));
                          }
                          let isAdmin = this.isAdmin() ? "true" : "false";
                          localStorage.setItem('isAdmin', encryptValue(isAdmin));
                          //swal.fire(`Entered OTP: ${result.value}`)
                          let rolesArray = JSON.parse(decryptValue(localStorage.getItem('Roles')));
                          let isAPUser = (rolesArray.indexOf('AP_ACCESS') > -1) ? true : false;
                          let isARUser = (rolesArray.indexOf('AR_ACCESS') > -1 || rolesArray.indexOf('CA_ACCESS') > -1) ? true : false;
                          let isVMUser = (rolesArray.indexOf('VM_ACCESS') > -1) ? true : false;

                          let isVPUser = (rolesArray.indexOf('VP_ACCESS') > -1) ? true : false;
                          if (isAPUser) {
                            this.router.navigate(['/dashboard']);
                          }
                          else if (isARUser) {
                            this.router.navigate(['/dashboard/ar']);
                          }
                          else if (isVMUser) {
                            this.router.navigate(['/dashboard/vm']);
                          }
                          else if (isVPUser) {
                            this.router.navigate(['/vendorportal/view']);
                          } else {
                            this.router.navigate(['/dashboard']);
                          }
                        }
                        else {
                          swal.fire({
                            title: 'Invalid OTP',
                            text: "Invalid OTP, please try again..!",
                            // type: 'error'
                            icon: 'error'
                          });
                        }
                      });
                  }
                });
              });
          }

          else {
            // console.log("token",PostData,PostData.token);
            console.log("operator",this.decodedToken.operator)
            localStorage.setItem('UserEmail', encryptValue(this.decodedToken.email));
            localStorage.setItem('UserToken', encryptValue(PostData.token));
            localStorage.setItem('IsAuthSuccessful', encryptValue('true'));
            localStorage.setItem('SessionTimer', encryptValue(JSON.stringify(this.decodedToken.sessionTimer)));
            localStorage.setItem('RoleAliasName', encryptValue(JSON.stringify(this.decodedToken.userRoleNames)));
            localStorage.setItem('Roles', encryptValue(JSON.stringify(this.decodedToken.userRoleAliasNames)));
            localStorage.setItem('IsCustomer', encryptValue(this.decodedToken.isCustomer));
            localStorage.setItem('IsCustomerAdmin',encryptValue(this.decodedToken.isCustomerAdmin));
            if (this.decodedToken.operator) {
            localStorage.setItem('operator', encryptValue(this.decodedToken.operator.join(',')));
            }
            let isAdmin = this.isAdmin() ? "true" : "false";
            localStorage.setItem('isAdmin', encryptValue(isAdmin));

          //  console.log("boxDataQR",decryptValue(localStorage.getItem('boxDataQR')))
          
            if (localStorage.getItem('isMobile') && decryptValue(localStorage.getItem('isMobile')) == "true") {
              this.getLatestSampleDetails(decryptValue(localStorage.getItem('QRSerialId')))
              .then(() => {
                this.router.navigate(['/sample/add']);
              })
              .catch(() => {
                this.router.navigate(['/sample/add']);
              });
            }
            else if (localStorage.getItem('boxDataQR') && decryptValue(localStorage.getItem('boxDataQR')) == "true") {
              console.log("Entering in box data url")
              this.router.navigate(['/sample/addboxData']);
            }
             else {
              this.router.navigate(['/sample/listing']);
            }
          //  this.router.navigate(['/sample/listing']);

          }
          // })
          // .catch(err => {
          //   console.log("Error Login", err);
          //   localStorage.setItem('InvalidUser', encryptValue('true'));
          //   swal.fire({
          //     title: 'Login Failed',
          //     text: "User does not have permissions to Login",
          //     // type: 'error'
          //     icon: 'error'
          //   });
          //   this.router.navigate(['/pages/login'], { queryParams: { error: 'invalid', message: err } });
          // })
        },
          err => {
            console.log("Error Login", err);
            localStorage.setItem('InvalidUser', encryptValue('true'));
            swal.fire({
              title: 'Login Failed',
              text: "User not found!",
              // type: 'error'
              icon: 'error'
            });
            this.router.navigate(['/pages/login'], { queryParams: { error: 'invalid', message: err } });
          });
    })
  }

  getLatestSampleDetails(qrCodeId: string) {
    return new Promise<void>((resolve, reject) => {
    const authToken = decryptValue(localStorage.getItem('UserToken'));
    const headers = {
      'access-token': authToken
    };
    this.http.get<any>(decryptValue(localStorage.getItem('BaseURL')) + '/qr_samplepointcode_mapping_service/latestSample/' + qrCodeId, { headers: headers })
      .subscribe((data) => {
        let sampleRes = data;
        console.log("Latest Sample Details", data.status, sampleRes);
        if (sampleRes) {
          localStorage.setItem('SampleData', encryptValue(JSON.stringify(sampleRes)));
          resolve();
        } else {
          console.error("Failed to fetch latest sample details");
          reject(new Error("Failed to fetch latest sample details"));
        }
      }, (err) => {
        console.error("Error fetching latest sample details", err);
        reject(err);
      });
    });
  }

  GetUserRoles(userId) {
    return new Promise((resolve, reject) => {
      this.http.get<any>(decryptValue(localStorage.getItem('BaseURL')) + '/authenticate_service/GetUserRoles/' + userId)
        .subscribe((data) => {
          if (data.length == 0) {
            reject(null);
          }
          else {
            this.http.get<any>(decryptValue(localStorage.getItem('BaseURL')) + '/authenticate_service/GetUserRoleAliasName/' + userId)
              .subscribe((dataAlias) => {
                console.log("Roles", data)
                console.log("RoleAliasName", dataAlias)
                localStorage.setItem('RoleAliasName', encryptValue(JSON.stringify(dataAlias)));
                localStorage.setItem('Roles', encryptValue(JSON.stringify(data)));
                let isAdmin = this.isAdmin() ? "true" : "false";
                localStorage.setItem('isAdmin', encryptValue(isAdmin));
                resolve(null);
              });
          }
        });
    });
  }

  logout() {
    this.modalService.dismissAll();
    swal.close();
    this.clearAllTimeouts();
    localStorage.clear();
    this.router.navigate(['/']);
  }

  clearAllTimeouts() {
    let highestTimeoutId = setTimeout(";");
    for (let i = 0; i < highestTimeoutId; i++) {
      clearTimeout(i);
    }
  };

  sessionManagement() {
    setTimeout(() => {    //<<<---    using ()=> syntax
      this.logout();
    }, Number(decryptValue(localStorage.getItem('SessionTimer'))) * 1000);

    setTimeout(() => {    //<<<---    using ()=> syntax
      swal.fire({
        title: 'Session expires in 2 minutes!!',
        text: "Your session will expires in 2 minutes!!",
        // type: 'warning',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Refresh Session!'
      }).then((result) => {
        if (result.value) {
          localStorage.removeItem('UserName');
          localStorage.removeItem('UserId');
          localStorage.removeItem('UserEmail');
          localStorage.removeItem('UserToken');
          localStorage.removeItem('IsAuthSuccessful');
          localStorage.removeItem('Roles');
          localStorage.removeItem('SessionTimer');
          localStorage.removeItem('PreviousPage');
          //clearTimeout(logoutTimeOut);
          this.clearAllTimeouts();

          let uname = decryptValue(localStorage.getItem('uname'));
          let uPassword = decryptValue(localStorage.getItem('uPassword'));
          //this.loginUser(localStorage.getItem('uname'), localStorage.getItem('uPassword'));

          const reqBody = { username: uname, password: uPassword };
          // console.log('request Body: ' + JSON.stringify(reqBody));
          this.http.post<any>(decryptValue(localStorage.getItem('BaseURL')) + '/authenticate_service/authenticate', reqBody)
            .subscribe((PostData) => {
              this.decodedToken = jwtDecode(PostData.token);
              localStorage.setItem('uname', encryptValue(uname));
              localStorage.setItem('uPassword', encryptValue(uPassword));
              localStorage.setItem('UserName', encryptValue(this.decodedToken.user_Name));
              localStorage.setItem('UserId', encryptValue(this.decodedToken.user_Id));
              localStorage.setItem('UserEmail', encryptValue(this.decodedToken.email));
              localStorage.setItem('UserToken', encryptValue(PostData.token));
              localStorage.setItem('IsAuthSuccessful', encryptValue('true'));
              localStorage.setItem('SessionTimer', encryptValue(JSON.stringify(this.decodedToken.sessionTimer)));
              this.GetUserRoles(this.decodedToken.user_Id);
              this.sessionManagement();
            },
              err => {
                localStorage.setItem('InvalidUser', encryptValue('true'));
                this.router.navigate([''], { queryParams: { error: 'invalid', message: err.error.message } });
              });
        }
      });
    }, (Number(decryptValue(localStorage.getItem('SessionTimer'))) - 120) * 1000);
  }

  getToken() {
    return this.token;
  }

  isAuthenticated() {
    const user_token = localStorage.getItem('UserToken') ? decryptValue(localStorage.getItem('UserToken')) : null;
    if (user_token != null) {
      return true;
    } else {
      return false;
    }
  }

  isAdmin() {
    const isAdmin = JSON.parse(decryptValue(localStorage.getItem('Roles'))).indexOf('ADMIN') > -1;
    const isCustomerAdmin = localStorage.getItem('IsCustomerAdmin') ?  decryptValue(localStorage.getItem('IsCustomerAdmin')) == "Y" ? true : false : false;
    //console.log(isAdmin)
    if (isAdmin || isCustomerAdmin) {
      return true;
    } else {
      return false;
    }
  }

  isNormalUser() {
    const isNormalUser = localStorage.getItem('IsCustomer') ?  decryptValue(localStorage.getItem('IsCustomer')) == "Y"  ? false : true : true;
    //console.log(isAdmin)
    if (isNormalUser) {
      return true;
    } else {
      return false;
    }
  }

  isVMApproval() {
    const isVMApproval = JSON.parse(decryptValue(localStorage.getItem('Roles'))).indexOf('VM_APPROVER') > -1;

    if (isVMApproval) {
      return true;
    } else {
      return false;
    }
  }

  isAPProcessor() {
    const isAPProcessor = JSON.parse(decryptValue(localStorage.getItem('RoleAliasName'))).indexOf('AP_INVOICE_PROCESSOR') > -1;

    if (isAPProcessor) {
      return true;
    } else {
      return false;
    }
  }

  isAPApprover() {
    const isAPApprover = JSON.parse(decryptValue(localStorage.getItem('RoleAliasName'))).indexOf('AP_INVOICE_APPROVER') > -1;
    if (isAPApprover) {
      return true;
    } else {
      return false;
    }
  }

  isAPExporter() {
    const isAPExporter = JSON.parse(decryptValue(localStorage.getItem('RoleAliasName'))).indexOf('AP_INVOICE_EXPORTER') > -1;
    if (isAPExporter) {
      return true;
    } else {
      return false;
    }
  }
}
